import { render, staticRenderFns } from "./OrganizationLiveEventsListContainer.vue?vue&type=template&id=62c0be19&scoped=true"
import script from "./OrganizationLiveEventsListContainer.vue?vue&type=script&lang=js"
export * from "./OrganizationLiveEventsListContainer.vue?vue&type=script&lang=js"
import style0 from "./OrganizationLiveEventsListContainer.vue?vue&type=style&index=0&id=62c0be19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c0be19",
  null
  
)

export default component.exports